const CollapseIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M19.4998 3.09009L14.9998 7.59009V4.00009H12.9998V11.0001H19.9998V9.00009H16.4098L20.9098 4.50009L19.4998 3.09009ZM3.99984 13.0001V15.0001H7.58984L3.08984 19.5001L4.49984 20.9101L8.99984 16.4101V20.0001H10.9998V13.0001H3.99984Z"
      fill="white"
    />
  </svg>
);

export default CollapseIcon;
